/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/text_embedding.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Generates dense vector embeddings from text input using a specified inference endpoint. Use this function to generate query vectors for KNN searches against your vectorized data or others dense vector based operations.
 *
 * @example
 * FROM dense_vector_text METADATA _score
 * | WHERE KNN(text_embedding_field, TEXT_EMBEDDING("be excellent to each other", "test_dense_inference"))
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'text_embedding',
  signatures: [
    {
      params: [
        {
          name: 'text',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'inference_id',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'entity',
            entityType: 'inference_endpoint',
            constraints: {
              task_type: 'text_embedding',
            },
          },
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'timeout\', values=[], description=\'Timeout for the inference request (e.g. "30s", "1m").\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'dense_vector',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
